/**
 * @fileoverview Trial API functions
 * 
 * Handles trial functionality:
 * - Trial status checking
 * 
 * @module api/trial
 */

import apiClient, { getAuthHeaders, getRestaurantId } from './client';

// ============================================================================
// TRIAL STATUS
// ============================================================================

/**
 * Get trial status for current restaurant
 * @returns {Promise} Trial status with limits and features
 */
export const getTrialStatus = async () => {
  const restaurantId = getRestaurantId();
  try {
    const response = await apiClient.get(`/trial/restaurants/${restaurantId}/status`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching trial status:', error);
    throw error;
  }
};



// ============================================================================
// EXPORTS
// ============================================================================

export const trialApi = {
  getTrialStatus,
};

export default trialApi;
